import { FormBase } from "../util/form-base-form";

class AdClickTrackingForm extends FormBase {
    public getClosestTrackableLink(root: EventTarget | Element | null | undefined): HTMLAnchorElement | null {
        return this.closest(
            root,
            "a.ad-slot__link, a.product-card__header-link, a.product-card__title",
            HTMLAnchorElement,
        );
    }

    public getClosestTrackableAdSlot(root: EventTarget | Element | null | undefined): HTMLElement | null {
        return this.closest(root, "[data-ad-id][data-ad-type]", HTMLElement);
    }
}

const adClickTrackingForm = new AdClickTrackingForm();

export { AdClickTrackingForm, adClickTrackingForm };
